import axios, {type AxiosInstance} from 'axios';

import {getCookie} from '../getCookie';
import {DY_HOST, API_CLIENT_KEY, EXP_DY_REQUEST_TIMEOUT} from 'general/constants';
import type {DyRequestDataType} from 'types/dy';
import type {ExtraPropsType} from 'types/general';
import {setPageAttributes} from './helpers';

export const getData = (
    instanceDY: AxiosInstance,
    dyRequestData: DyRequestDataType,
    extraProps: ExtraPropsType,
) => {
    const {isPrivacyPolicyTurnedOn, cartItemsCount} = extraProps;
    if (isPrivacyPolicyTurnedOn && !getCookie('is_visible_privacy_policy')) {
        return null;
    }

    if (process.env.NODE_ENV === 'development') {
        return axios({
            method: 'POST',
            url: `${DY_HOST}/v2/serve/user/choose`,
            baseURL: `${DY_HOST}`,
            data: {
                selector: {
                    names: dyRequestData.selectors,
                },
                preview: {},
                userId: getCookie('_dyid'),
                serverId: getCookie('_dyid_server'),
                sessionId: getCookie('_dyjsession'),
                context: {
                    page: {
                        type: 'OTHER',
                        location: 'https://glassesusa.dev/',
                        locale: 'en_US',
                        referrer: document?.referrer,
                        data: [],
                    },
                    device: {
                        userAgent: window?.navigator?.userAgent || '',
                        ip: '128.69.59.103',
                    },
                    pageAttributes: {
                        ...setPageAttributes(),
                        cartItemsCount,
                        testDY: String(getCookie('testDY') || ''),
                        isMContactsPopupFlagOn: String(extraProps.isMContactsPopupFlagOn || false),
                        isDContactsPopupFlagOn: String(extraProps.isDContactsPopupFlagOn || false),
                        isMCRMCPriceFlag: String(extraProps.MCRMCPriceFlag || false),
                        isDCRMCPriceFlag: String(extraProps.DCRMCPriceFlag || false),
                        isDHPPopupNav: String(extraProps.isDHPPopupNav || false),
                        isMHPPopupNav: String(extraProps.isMHPPopupNav || false),
                    },
                },
            },
            headers: {
                'dy-api-key': API_CLIENT_KEY,
                'Content-Type': 'application/json',
            },
        });
    }

    return instanceDY({
        method: 'POST',
        url: `${DY_HOST}/v2/serve/user/choose`,
        baseURL: `${DY_HOST}`,
        data: {
            selector: {
                names: dyRequestData.selectors,
            },
            context: {
                ...dyRequestData.context,
                pageAttributes: {
                    ...setPageAttributes(),
                    isMContactsPopupFlagOn: String(extraProps.isMContactsPopupFlagOn || false),
                    isDContactsPopupFlagOn: String(extraProps.isDContactsPopupFlagOn || false),
                    isMCRMCPriceFlag: String(extraProps.MCRMCPriceFlag || false),
                    isDCRMCPriceFlag: String(extraProps.DCRMCPriceFlag || false),
                    isDHPPopupNav: String(extraProps.isDHPPopupNav || false),
                    isMHPPopupNav: String(extraProps.isMHPPopupNav || false),
                    cartItemsCount,
                },
            },
        },
        ...(extraProps.isDyRequestOptionsOn ? {timeout: EXP_DY_REQUEST_TIMEOUT} : {}),
    });
};
